import { useSimpleNotification } from '../providers/simple-notification-provider';

export const useSnackbarNotifier = () => {
  const { show,close } = useSimpleNotification();
  return [show,close];
};
